module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAAcCAYAAACERFoMAAAAAXNSR0IArs4c6QAAAUhJREFUaEPtmrFKw1AYhb8rNgUFi4ttF626Ce66ull8AxdBTDIJujo76gMUOvkQPoCDm40Oznao9QkceyWCILHOvX/vyRYy3HPOx+HmJr+jcvmns0PcQh9oV5/pfqYJjPGTU/cH2CB7p5O2WdqYqTotXkngcwhvvfE0YJ6da+UVYgKvVwhYiGD+0yRglmgBAiZgxhIwJlcNEzBjCRiTq4YZB+aL/IJk7Zbtc2NOIpH7u2F+kB9TW7mjkzlqjUgSMGbzB5h/zg+gfs9mmlBvGnMRkdwSmH9Jd5ksPrB+0mB5KyL3Bq1+AyuyR1b392gdGXQQmWQ1zBhw7WFGgZWy9ZZoAF714OyL7JKkeaNzWKDw9KUjUDD6H2YMjIAJ2JwkYMyG9jABM5aAMblq2HwA0yBpiBzLQdJh72PaXGIXRx9PK0TdEWsaAekXncGbL+yIM2sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/figure.png
// module id = brZo
// module chunks = 36